import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { BrandLockup } from './BrandLockup';
import { ButtonLink } from '../ui/ButtonLink';
import { primaryNav, SYNEURAL_URL } from '../../data/navigation';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const solid = scrolled || open;
  return <header className="sticky top-0 z-50" data-id="element-118" data-mp="pwx7sgj4v2me">
      <div className={`border-b transition-[background-color,border-color] duration-200 ease-out ${solid ? 'glass-bar border-ink/[0.06]' : 'border-transparent'}`} data-id="element-119" data-mp="ux1syjuzkliy">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:px-8" data-id="element-120" data-mp="3t09lu694zfbc">
          <BrandLockup data-id="element-121" data-mp="3o0oep8jtc0nj" />

          <nav aria-label="Primary" className="hidden items-center gap-1 md:flex" data-id="element-122" data-mp="3o1ydy12ejevr">
            {primaryNav.map(item => <NavLink key={item.label} to={item.to ?? '/'} className={({
            isActive
          }) => `rounded-full px-3.5 py-2 text-sm font-medium transition-colors duration-150 ease-out ${isActive ? 'bg-white/80 text-ink shadow-sm' : 'text-ink-soft hover:text-ink'}`} data-id="element-123" data-mp="3k1xm9eqal76r">
                {item.label}
              </NavLink>)}
          </nav>

          <div className="flex items-center gap-2" data-id="element-124" data-mp="13csaelwufj84">
            <ButtonLink to="/contact" size="sm" className="hidden sm:inline-flex" data-id="element-125" data-mp="yjz43tlq82tx">
              Request a Demo
            </ButtonLink>
            <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-9 w-9 items-center justify-center rounded-full text-ink transition-colors duration-150 hover:bg-white/80 md:hidden" data-id="element-126" data-mp="2ssutnvt501p3">
              {open ? <XIcon className="h-5 w-5" data-id="element-127" data-mp="2a0a68tw7ioso" /> : <MenuIcon className="h-5 w-5" data-id="element-128" data-mp="2f0y4o0mrm7wx" />}
            </button>
          </div>
        </div>

        <AnimatePresence initial={false} data-id="element-129" data-mp="2eylfp3ilaxad">
          {open ? <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
          opacity: 0,
          y: -6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -6
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="border-t border-ink/[0.06] px-5 pb-6 pt-3 md:hidden" data-id="element-130" data-mp="2058dzp6mx6lv">
              <ul className="flex flex-col" data-id="element-131" data-mp="1nu7okfclmkkx">
                {primaryNav.map(item => <li key={item.label} data-id="element-132" data-mp="1ive7kcy3sbg0">
                    <NavLink to={item.to ?? '/'} className={({
                isActive
              }) => `block py-3 text-lg font-medium ${isActive ? 'text-accent' : 'text-ink'}`} data-id="element-133" data-mp="1is9zh4hiovk2">
                      {item.label}
                    </NavLink>
                  </li>)}
                <li data-id="element-134" data-mp="22hkfkjl6diip">
                  <a href={SYNEURAL_URL} target="_blank" rel="noopener noreferrer" className="block py-3 text-sm text-ink-muted" data-id="element-135" data-mp="22kexa3ct0p8f">
                    Noetivra by SyNeural
                  </a>
                </li>
              </ul>
              <ButtonLink to="/contact" className="mt-3 w-full" data-id="element-136" data-mp="m3u6eyf78427">
                Request a Demo
              </ButtonLink>
            </motion.nav> : null}
        </AnimatePresence>
      </div>
    </header>;
}